import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* updateJourneyVehicle(params) {
  try {
    const intervention = yield call(function() {
      return Api.put(`/intervention/${params.id}/vehicle`, params.body)
    });
    yield put({type: 'UPDATE_JOURNEY_VEHICLE.SUCCESS', intervention});
    yield put({type: 'SHOW_NOTIFICATION', notification:{message:'save.success'}});
  } catch (error) {
    yield put({type: 'UPDATE_JOURNEY_VEHICLE.FAILURE', error});
  }
}

export function* watchUpdateJourneyVehicle() {
  yield takeEvery('UPDATE_JOURNEY_VEHICLE.REQUEST', updateJourneyVehicle)
}
